export interface Action {
  type: string;
  payload?: unknown;
}

export type RequestStatus = 'idle' | 'loading' | 'error' | 'success';

export class RequestActions {
  private readonly name: string;

  constructor(name: string) {
    this.name = name;
  }

  public started(payload: unknown = undefined) {
    return {
      type: `${this.name} Started`,
      payload,
    };
  }

  public success(payload: unknown = undefined) {
    return {
      type: `${this.name} Success`,
      payload,
    };
  }

  public error(payload: unknown = undefined) {
    return {
      type: `${this.name} Error`,
      payload,
    };
  }
}
